import "styles/calculatorTabSwitch.less";

import React, { useContext } from "react";

import { Typography, Select } from "antd";
import { AppContext } from "App";
import iconEmployment from "assets/images/new-questionnaire/navigation/undone-step-employment.svg";
import iconSelfEmployment from "assets/images/new-questionnaire/navigation/undone-step-self-employment.svg";

const CalculatorTabSwitch: React.FC = () => {
    const { isMobile } = useContext(AppContext);
    return (
        <div>
            {isMobile ? (
                <div>
                    <Typography className={"calculator-tab-switch__tax-calc-text-mobile"}>
                        Tax Calculators
                    </Typography>
                    <Select
                        defaultValue="employ"
                        options={[
                            { value: "employ",
                                label: (
                                    <div className={"calculator-tab-switch__select-label"}>
                                        <img src={iconEmployment} alt="" style={{ width: 30, height: 30 }} />
                                        <Typography className={"calculator-tab-switch__select-label-text"}>Employment Calculator</Typography>
                                    </div>
                                ) },
                            { value: "selfEmploy",
                                label: (
                                    <div className={"calculator-tab-switch__select-label"}>
                                        <img src={iconSelfEmployment} alt="" style={{ width: 30, height: 30 }} />
                                        <Typography className={"calculator-tab-switch__select-label-text"}>Self-employment Calculator</Typography>
                                    </div>
                                ) },
                        ]}
                        className={"calculator-tab-switch__select"}
                    />
                </div>
            ) : (
                <div className={"calculator-tab-switch__container-desktop"}>
                    <button className={"shared__secondary-button calculator-tab-switch__self-employ-button-desktop"}>
                        <img src={iconSelfEmployment} alt="" style={{ width: 30, height: 30 }} />
                        Self-employment
                    </button>
                    <button className={"shared__secondary-button calculator-tab-switch__employ-button-desktop"}>
                        <img src={iconEmployment} alt="" style={{ width: 30, height: 30 }} />
                        Employment
                    </button>
                </div>
            )}
        </div>
    );
};

export default CalculatorTabSwitch;
